import APICall from "../utils/APICall";

export default class ThirdPartyServices {
  // Organization APIs
  static onboardOrganization = async (data) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/on-board`,
      "POST",
      data,
    );
  };

  static listOrganizations = async (page = 1, limit = 10) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/list-organizations?page=${page}&pagelimit=${limit}`,
      "GET",
    );
  };

  static fetchOrganization = async (searchParameter) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/fetch-organization?searchParameter=${encodeURIComponent(searchParameter)}`,
      "GET",
    );
  };

  static sendAccountNotification = async (data) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/account-opening-notification/send`,
      "POST",
      data,
    );
  };

  static createOrganization = async (data) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/create`,
      "POST",
      data,
    );
  };

  static getOrganization = async (PremiumMobileUserId, OrganisationId) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/view?PremiumMobileUserId=${PremiumMobileUserId}&OrganisationId=${OrganisationId}`,
      "GET",
    );
  };

  static updateOrganization = async (data) => {
    return await APICall(
      `/api/ThirdPartyOrganization/admin/organization/update`,
      "POST",
      data,
    );
  };

  // Application APIs
  static createApplication = async (data) => {
    return await APICall(
      `/api/ThirdPartyApplication/admin/application/on-board`,
      "POST",
      data,
    );
  };

  static getApplication = async (searchParameter) => {
    return await APICall(
      `/api/ThirdPartyApplication/admin/application/fetch-application?searchParameter=${encodeURIComponent(searchParameter)}`,
      "GET",
    );
  };

  static listApplications = async (page = 1, limit = 10) => {
    return await APICall(
      `/api/ThirdPartyApplication/admin/application/list-all?page=${page}&pageLimit=${limit}`,
      "GET",
    );
  };

  // Employees APIs
  static listCustomers = async (page = 1, limit = 10, organizationId) => {
    if (!organizationId || organizationId === "undefined") {
      return { status: false, message: "Organization ID is required" };
    }

    return await APICall(
      `/api/ThirdPartyEmployee/admin/list-organisation-employees?page=${page}&pageLimit=${limit}&OrganisationId=${organizationId}`,
      "GET",
    );
  };

  static sendEmployeeNotification = async (data) => {
    return await APICall(
      `/api/ThirdPartyEmployee/admin/employee/account-opening-notification/send`,
      "POST",
      data,
    );
  };

  static getCustomer = async (searchParameter) => {
    return await APICall(
      `/api/ThirdPartyEmployee/admin/fetch-customer?searchParameter=${encodeURIComponent(searchParameter)}`,
      "GET",
    );
  };

  //payroll officer APIs

    static createPayrollOfficer = async (data) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/create`,
      "POST",
      data,
    );
  };

    static listPayrollOfficers = async (organizationId, page = 1, pageSize = 10, startDate = null, endDate = null) => {
    if (!organizationId) {
      return { status: false, message: "Organization ID is required" };
    }

    let url = `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/list-all?organizationId=${organizationId}&page=${page}&pageSize=${pageSize}`;
    
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      url += `&endate=${encodeURIComponent(endDate)}`;
    }

    return await APICall(url, "GET");
  };

   static updatePayrollOfficerStatus = async (data) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/status-update`,
      "PUT",
      data,
    );
  };

   static updatePayrollOfficer = async (data) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/update`,
      "PUT",
      data,
    );
  };

    static searchPayrollOfficer = async (organizationId, searchTerm) => {
    const response = await this.listPayrollOfficers(organizationId, 1, 100);
    
    if (response.status && response.data?.result) {
      const filtered = response.data.result.filter(officer => 
        officer.payrollOfficerId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        officer.emailAddress?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        officer.phoneNumber?.includes(searchTerm) ||
        officer.bvn?.includes(searchTerm)
      );
      
      return {
        ...response,
        data: {
          ...response.data,
          result: filtered,
          totalCount: filtered.length
        }
      };
    }
    
    return response;
  };

  // ===== Payroll Officer View =====

  static viewPayrollOfficer = async (organizationId, payrollOfficerId) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/view?organizationId=${encodeURIComponent(organizationId)}&payrollofferId=${encodeURIComponent(payrollOfficerId)}`,
      "GET",
    );
  };

  // ===== Pre-Onboarded Payroll Officers =====

  static viewPreOnboardedPayrollOfficer = async (organizationId, payrollOfficerId) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/view-pre-onboarded?organizationId=${encodeURIComponent(organizationId)}&payrollofferId=${encodeURIComponent(payrollOfficerId)}`,
      "GET",
    );
  };

  static listPreOnboardedPayrollOfficers = async ({
    search,
    status,
    organizationId,
    page = 1,
    pageSize = 10,
    startDate,
    endDate,
  } = {}) => {
    let url = `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/list-all-preonboarded?organizationId=${encodeURIComponent(organizationId)}&page=${page}&pageSize=${pageSize}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (status) {
      url += `&status=${encodeURIComponent(status)}`;
    }
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      url += `&endDate=${encodeURIComponent(endDate)}`;
    }

    return await APICall(url, "GET");
  };

  static approveOrRejectPreOnboarded = async (data) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/approve-or-reject-pre-onboarded`,
      "POST",
      data,
    );
  };

  static sendWebhookNotification = async (data) => {
    return await APICall(
      `/api/ThirdPartyPayrollOfficer/admin/payroll-officer/webhook-notification/send`,
      "POST",
      data,
    );
  };

  // ===== Payroll Transactions =====

  static listPayrollTransactions = async ({
    tenantId,
    userId,
    batchNumber,
    pageIndex = 1,
    pageSize = 10,
    startDate,
    endDate,
    processStatus,
    transferType,
    search,
  } = {}) => {
    let url = `/api/ThirdPartyPayrollTransaction/admin/thirdparty/list-payroll-transactions?tenantId=${encodeURIComponent(tenantId)}&userId=${encodeURIComponent(userId)}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    if (batchNumber) {
      url += `&batchNumber=${encodeURIComponent(batchNumber)}`;
    }
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      url += `&endDate=${encodeURIComponent(endDate)}`;
    }
    if (processStatus) {
      url += `&processStatus=${encodeURIComponent(processStatus)}`;
    }
    if (transferType) {
      url += `&transferType=${encodeURIComponent(transferType)}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return await APICall(url, "GET");
  };

  static viewPayrollTransaction = async (tenantId, userId, payrollTransactionId) => {
    return await APICall(
      `/api/ThirdPartyPayrollTransaction/admin/thirdparty/view-payroll-transaction?tenantId=${encodeURIComponent(tenantId)}&userId=${encodeURIComponent(userId)}&payrollTransactionId=${encodeURIComponent(payrollTransactionId)}`,
      "GET",
    );
  };
}
